/**
 * @author mi
 * @date 2019/1/24
 * @project kaoshizhongxin-pc
 * @desc 进度条
 */
import app from '../main'
export const progress = {
  start () {
    if (app && app.$Progress) {
      app.$Progress.start()
    }
  },
  finish () {
    if (app && app.$Progress) {
      app.$Progress.finish()
    }
  },
  fail () {
    if (app && app.$Progress) {
      app.$Progress.fail()
    }
  }
}
